module.exports = __webpack_public_path__ + "img/Tu4yrA4JFn-cropped.e16ecb91.gif";